export const ROOT: string = '/';
export const ABOUT: string = '/about';
export const CITY: string = '/city';
export const GAME: string = '/game';
export const SUCCESS: string = '/success';
export const KEYBOARD: string = '/keyboard';
export const DIPLOMA: string = '/diploma';
